import { httpClient } from '../http/httpClient'

export interface UserAdminUpdateDataResponse {
  _id: string
  name: string
  email: string
  phone: string
  birthDate: string
  address: {
    zipCode: string
    state: string
    city: string
    neighborhood: string
    street: string
    number: string
  }
  bankAccount: {
    bank: string
    agency: string
    account: string
    accountType: string
    pixKey: string
    pixType: string
  }
}

export interface UserAdminUpdateData {
  _id?: string
  name?: string
  email?: string
  phone?: string
  birthDate?: string
  address?: {
    zipCode?: string
    state?: string
    city?: string
    neighborhood?: string
    street?: string
    number?: string
  }
  bankAccount?: {
    bank?: string
    agency?: string
    account?: string
    accountType?: string
    pixKey?: string
    pixType?: string
  }
}

export async function userAdminUpdate(updateData: UserAdminUpdateData) {
  const { data } = await httpClient.put<UserAdminUpdateDataResponse>(
    '/user/me',
    updateData,
    {
      headers: {
        'x-mock-response-name': 'Update User',
      },
    },
  )

  return data
}
